import React, { useState, useCallback } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from '@/components/ui/dialog';
import { Card } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Send } from 'lucide-react';

const QuickReplyModal = ({ isOpen, onClose, interaction, onSendReply }) => {
  const [replyText, setReplyText] = useState('');

  const handleSend = useCallback(() => {
    if (replyText.trim()) {
      onSendReply(interaction.id, replyText);
      setReplyText('');
      onClose();
    }
  }, [replyText, interaction, onSendReply, onClose]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl" style={{ zIndex: 1001 }}>
        <DialogHeader>
          <DialogTitle>Quick Reply to {interaction?.contactName}</DialogTitle>
          <DialogDescription>
            Send a quick response to this interaction
          </DialogDescription>
        </DialogHeader>
        {interaction && (
          <div className="space-y-4">
            <Card className="p-4 bg-muted">
              <h4 className="font-medium mb-2">Original Message</h4>
              <div className="text-sm">
                {interaction.content}
              </div>
            </Card>

            <div>
              <Label htmlFor="reply-text">Your Reply</Label>
              <Textarea
                id="reply-text"
                value={replyText}
                onChange={(e) => setReplyText(e.target.value)}
                placeholder="Type your reply here..."
                rows={6}
              />
            </div>

            <div className="flex justify-end space-x-2">
              <Button variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button onClick={handleSend} disabled={!replyText.trim()}>
                <Send className="mr-2 h-4 w-4" />
                Send Reply
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default QuickReplyModal;